import type {
  CommunicationChannel,
  DefaultPricingFormValues,
} from './types/defaultPricing';

export const COMMUNICATION_CHANNEL_CHOICES: Array<{
  id: CommunicationChannel;
  name: string;
}> = [
  { id: 'Email', name: 'Email' },
  { id: 'SMS', name: 'SMS' },
  { id: 'Whatsapp', name: 'Whatsapp' },
  { id: 'Telegram', name: 'Telegram' },
  { id: 'Push', name: 'Push' },
];

export const createEmptyDefaultPricingFormValues = (): DefaultPricingFormValues => ({
  communicationChannel: '',
  amount: 0,
});
